const SearchHistoryManager = ((win) => {

	//let onStateChangedHandler = () => { };

 //   win.onpopstate = function (e) {

	//	let state = new SearchQuery();

	//	if (e.state) {
	//		state = $.extend(state, e.state);
	//	}
 //       console.log(["popping state", state]);
	//	onStateChangedHandler(state);
	//};

	//win.addEventListener('load', () => {
        
	//	let url = win.location.href;
	//	let qs = $.queryString.parse(url);
 //       console.log(qs);
 //       if (!$.isEmptyObject(qs)) {
 //           let newState = new SearchQuery();
            
 //           $.extend(newState, qs);
 //           console.log(["loading", newState]);
 //           history.replaceState(newState, location.href, location.href);
 //       }
	//});

	function updateState(state) {

		const newState = new SearchQuery();

		$.extend(newState, state);

		let newUrl = win.location.origin + win.location.pathname + $.queryString.build(newState);

		history.pushState(newState, newUrl, newUrl);
	}

	return {
		updateState: updateState,
		onStateChanged: function (fn) {
			onStateChangedHandler = fn;
		}
	};

})(window);

class SearchQuery {
	constructor() {
		this.query = "";
		this.t = "";
		this.l = "";
		this.p = 1;
	}
}